export const SUPPORT_EMAIL = 'TRANSLATIONHUB@bswhealth.org';